import "../../vm/view"
import {VNode} from "../../vm/vnode";
import {div, h3} from "../../vm/hscript-esm"
let V = new View('Vi',{
    props: {
        a: 0
    },
    onCreate() {
        console.log('hi')
    },
    render() {
        return div({}, "Hi")
    }
})

class Z extends View {
    constructor() {
        super();
    }
    render() {
        return div( {}, "Z tag")
    }
}

// let Zi = new Z()

global.Z = Z
global.V = V
// console.log(Zi.createInstance({a:2}).createInstance({b: 77}))